export default "__VITE_ASSET__D6SgtC$Q__"